export const PortfolioUploadStatus = () => {
  const portfolioData = [
    {
      mandate: "Innovate Zurich AG",
      files: "152 / 300",
      progress: 51,
      status: "Processing",
      statusColor: "bg-blue-100 text-blue-800",
      assignee: {
        name: "Lukas Müller",
        avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg"
      },
      priority: "High",
      priorityColor: "text-brand-danger"
    },
    {
      mandate: "Geneva Watchmakers",
      files: "45 / 45",
      progress: 100,
      status: "Completed",
      statusColor: "bg-brand-success-bg text-brand-success",
      assignee: {
        name: "Sophie Dubois",
        avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg"
      },
      priority: "Normal",
      priorityColor: "text-brand-text-secondary"
    },
    {
      mandate: "Alpine Logistics",
      files: "88 / 250",
      progress: 35,
      status: "Errors Found",
      statusColor: "bg-brand-danger-bg text-brand-danger",
      assignee: {
        name: "Matteo Rossi",
        avatar: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg"
      },
      priority: "Medium",
      priorityColor: "text-brand-warning"
    },
    {
      mandate: "Swiss Chocolate Co.",
      files: "0 / 500",
      progress: 0,
      status: "Pending",
      statusColor: "bg-gray-100 text-gray-800",
      assignee: null,
      priority: "Normal",
      priorityColor: "text-brand-text-secondary"
    }
  ];

  return (
    <section className="bg-white p-6 rounded-2xl border border-brand-border mb-header-mb">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-bold text-brand-primary">Portfolio Upload Status</h3>
        <div className="flex items-center gap-2">
          <button className="h-7 px-2.5 py-1.5 bg-brand-secondary rounded-[7px] justify-center items-center gap-1 inline-flex text-center text-brand-primary text-[10px] leading-[10px]">
            <i className="fa-solid fa-filter text-xs"></i>
            <span>Filter by Status</span>
            <i className="fa-solid fa-caret-down ml-1"></i>
          </button>
          <button className="h-7 px-2.5 py-1.5 bg-brand-primary rounded-[7px] justify-center items-center gap-1 inline-flex text-center text-brand-white text-[10px] leading-[10px]">
            <i className="fa-solid fa-plus text-xs"></i>
            <span>New Bulk Upload</span>
          </button>
        </div>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-brand-secondary rounded">
            <tr>
              <th className="px-4 py-2 text-left text-[10px] text-brand-text-secondary font-medium tracking-wider">MANDATE</th>
              <th className="px-4 py-2 text-left text-[10px] text-brand-text-secondary font-medium tracking-wider">FILES</th>
              <th className="px-4 py-2 text-left text-[10px] text-brand-text-secondary font-medium tracking-wider">PROGRESS</th>
              <th className="px-4 py-2 text-left text-[10px] text-brand-text-secondary font-medium tracking-wider">STATUS</th>
              <th className="px-4 py-2 text-left text-[10px] text-brand-text-secondary font-medium tracking-wider">ASSIGNED TO</th>
              <th className="px-4 py-2 text-left text-[10px] text-brand-text-secondary font-medium tracking-wider">PRIORITY</th>
              <th className="px-4 py-2 text-left text-[10px] text-brand-text-secondary font-medium tracking-wider">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {portfolioData.map((item, index) => (
              <tr key={item.mandate} className={index < portfolioData.length - 1 ? "border-b border-brand-border" : ""}>
                <td className="px-4 py-3 whitespace-nowrap text-xs text-brand-text-primary font-medium">
                  {item.mandate}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-xs text-brand-text-secondary">
                  {item.files}
                </td>
                <td className="px-4 py-3">
                  <div className="w-full bg-gray-200 rounded-full h-1.5">
                    <div 
                      className={`h-1.5 rounded-full ${
                        item.progress === 100 ? 'bg-brand-success' : 
                        item.progress > 0 ? 'bg-brand-primary' : 'bg-gray-400'
                      }`}
                      style={{ width: `${item.progress}%` }}
                    ></div>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <span className={`px-2.5 py-1 text-xs font-medium rounded-2xl ${item.statusColor}`}>
                    {item.status}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    {item.assignee ? (
                      <>
                        <img src={item.assignee.avatar} className="w-6 h-6 rounded-full" alt="Assignee" />
                        <span className="text-xs text-brand-text-primary">{item.assignee.name}</span>
                      </>
                    ) : (
                      <>
                        <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center text-gray-500">
                          <i className="fa-solid fa-user-plus text-xs"></i>
                        </div>
                        <span className="text-xs text-brand-text-secondary italic">Unassigned</span>
                      </>
                    )}
                  </div>
                </td>
                <td className="px-4 py-3">
                  <span className={`font-medium text-xs ${item.priorityColor}`}>{item.priority}</span>
                </td>
                <td className="px-4 py-3">
                  <button className="text-brand-primary text-xs">
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};